enum ApiErrors {
  absenceDateCannotBeOverlappingError = 'AbsenceDateCannotBeOverlappingError',
}

export default ApiErrors;
